import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function Image({
  src,
  alt,
  width,
  height,
  className,
  'data-test-id': dataTestId,
  ...rest
}) {
  if (process.env.NODE_ENV !== 'production') {
    if (width === undefined || height === undefined) {
      // eslint-disable-next-line no-console
      console.warn(
        `[Image] Missing explicit width or height for src="${src}". ` +
          'Add width and height props to prevent layout shift (CLS).'
      );
    }
    if (
      src &&
      (src.includes('width=undefined') || src.includes('height=undefined'))
    ) {
      // eslint-disable-next-line no-console
      console.warn(
        `[Image] Generated URL contains undefined dimension: "${src}". ` +
          'Pass numeric width and height props to Image.'
      );
    }
  }
  return (
    <LazyLoadImage
      alt={alt}
      width={width}
      height={height}
      threshold={0.01}
      className={className}
      useIntersectionObserver
      data-test-id={dataTestId}
      src={
        src
          ? `${src}${src.includes('?') ? '&' : '?'}${
              width != null ? `width=${width}&` : ''
            }${height != null ? `height=${height}` : ''}`
          : ''
      }
      {...rest}
    />
  );
}

Image.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  'data-test-id': PropTypes.string.isRequired,
};

Image.defaultProps = {
  className: '',
};

export default Image;
